import { useState } from "react";

import { IGiveawayAuto } from "../../../interfaces";
import GiveawaysAutoService from "../../../services/http/services/GiveawaysAutoService";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";

export default function useNewGiveawayAuto() {
    const [createdGiveaway, setCreatedGiveaway] = useState<IGiveawayAuto | undefined>();

    async function handleSubmit(giveawayAuto: IGiveawayAuto) {
        const newGiveaway = await GiveawaysAutoService.createGiveaway(giveawayAuto);

        EmitSuccessAlert('Sorteio cadastrado com sucesso!');
        setCreatedGiveaway(newGiveaway);
    }

    return {
        handleSubmit,
        createdGiveaway,
    }
}
